import { useLocation, useParams } from "react-router";
import React, { useState, useEffect, useHistory, useRef } from "react";

import axios from "axios";
import jwt_decode from "jwt-decode";
import "../modal.css";

import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Spinner";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { Box, Stack, Typography, Button } from "@mui/material";
import { ImportExport } from "@mui/icons-material";

const Transactions = ({ type }) => {
  const location = useLocation();
  let [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);

  const param = useParams();
  const getTransactions = async () => {
    let response;

    if (type === "company") {
      response = await axios
        .get("companyTransactions/" + param.id, {})
        .then((res) => {
          console.log("=====company transactions===1====", res.data);

          // Merge passenger and driver names in the response
          const transactionsWithMergedNames = res.data.map((transaction) => {
            const passengerName = `${transaction.passenger.firstName} ${transaction.passenger.lastName}`;
            const driverName = `${transaction.driver.firstName} ${transaction.driver.lastName}`;

            return {
              ...transaction,
              passenger: { ...transaction.passenger, name: passengerName },
              driver: { ...transaction.driver, name: driverName },
            };
          });

          setTransactions(transactionsWithMergedNames);
          setLoading(false);
          // notify()
        })
        .catch((err) => {
          setLoading(false);
          notifyError();
        });
    } else if (type === "driver") {
      response = await axios
        .get("driverTransactions/" + param.id, {})
        .then((res) => {
          const transactionsWithMergedNames = res.data.map((transaction) => {
            const passengerName = `${transaction.passenger.firstName} ${transaction.passenger.lastName}`;
            const driverName = `${transaction.driver.firstName} ${transaction.driver.lastName}`;

            return {
              ...transaction,
              passenger: { ...transaction.passenger, name: passengerName },
              driver: { ...transaction.driver, name: driverName },
            };
          });

          setTransactions(transactionsWithMergedNames);
          setLoading(false);
          // notify()
        })
        .catch((err) => {
          setLoading(false);
          notifyError();
        });
    }
  };

  const notify = () =>
    toast.success("Vehicles list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  useEffect(() => {
    getTransactions();
  }, [location.key]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Passenger",
        columns: [
          {
            Header: "Id",
            accessor: "id",
          },
          {
            Header: "First Name",
            accessor: "passenger.firstName",
          },
          {
            Header: "Last Name",
            accessor: "passenger.lastName",
          },
          {
            Header: "Phone Number",
            accessor: "passenger.phoneNumber",
          },
        ],
      },
      {
        Header: "Driver",
        columns: [
          {
            Header: "First Name",
            accessor: "driver.firstName",
          },
          {
            Header: "Last Name",
            accessor: "driver.lastName",
          },
          {
            Header: "Phone Number",
            accessor: "driver.phoneNumber",
          },
        ],
      },

      {
        Header: "Trip",
        columns: [
          // {
          //   Header: "Revenue in ETB",
          //   accessor: "trip.revenue",
          // },
          {
            Header: "PickUp",
            accessor: "trip.pickUpPlace",
          },
          {
            Header: "Destination Place",
            accessor: "trip.destinationPlace",
          },
          {
            Header: "Total Price in ETB",
            accessor: "trip.actualPrice",
          },
          {
            Header: "Transaction Date",
            accessor: "trip.createdAt",
          },
        ],
      },
    ],
    []
  );

  const columns_expo = React.useMemo(
    () =>
      [
        {
          columns: [
            {
              Header: "Id",
              accessor: "id",
            },
          ],
        },
        {
          Header: "Passenger",
          columns: [
            { Header: "Passenger Name", accessor: "passenger.name" },
            // { Header: "Last Name", accessor: "passenger.lastName" },
            { Header: "Passenger Phone", accessor: "passenger.phoneNumber" },
          ],
        },
        {
          Header: "Driver",
          columns: [
            { Header: "Driver Name", accessor: "driver.name" },
            // { Header: "Last Name", accessor: "driver.lastName" },
            { Header: "Driver Phone", accessor: "driver.phoneNumber" },
          ],
        },
        {
          Header: "Trip",
          columns: [
            { Header: "Price", accessor: "trip.actualPrice" },
            // { Header: "Revenue", accessor: "trip.revenue" },
            { Header: "PickUp", accessor: "trip.pickUpPlace" },
            { Header: "Destination", accessor: "trip.destinationPlace" },
            { Header: "Date", accessor: "trip.createdAt" },
          ],
        },
      ].flatMap((group) => group.columns),
    []
  );

  function handleExportClick(transactions, columns) {
    const doc = new jsPDF();

    doc.text("Corporate Transactions", 10, 10);

    const tableData = transactions.map((transaction) =>
      columns.map((column) => {
        const accessorKeys = column.accessor.split("."); // Split nested accessors
        let data = transaction;

        // Traverse through nested objects
        for (const key of accessorKeys) {
          if (data[key] !== undefined) {
            data = data[key];
          } else {
            data = ""; // Handle case where data is missing
            break;
          }
        }

        console.log(`Column: ${column.Header}, Data:`, data); // Debugging
        return data;
      })
    );

    console.log("Table data:", tableData); // Debugging

    const tableWidth = "auto"; // Set the desired table width ('auto' or a specific number)
    const margin = { top: 15, right: 15, bottom: 15, left: 15 }; // Adjust margins as needed

    doc.autoTable({
      head: [columns.map((column) => column.Header)],
      body: tableData,
      tableWidth,
      // margin,
    });

    // doc.autoTable({
    //   head: [columns.map((column) => column.Header)],
    //   body: tableData,
    // });

    doc.save("corporate_transactions.pdf");
  }

  return (
    <div>
      <div className="col-13">
        <div className="card">
        <Box sx={{ p: 2, pt: 2, backgroundColor: "background.paper", borderRadius: 2, boxShadow: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h5" sx={{ fontWeight: 600, color: "text.primary", display: "flex", alignItems: "center", gap: 1 }}>
          <Box component="span" sx={{ width: 4, height: 24, backgroundColor: "primary.main", borderRadius: "2px", display: "block" }} />
          Corporate Transactions
        </Typography>
        <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
          
          <Button variant="outlined" color="secondary" startIcon={<ImportExport />}
            onClick={() => handleExportClick(transactions, columns_expo)}

           >
            Export
          </Button>
          
        </Stack>
      </Box>

         
          <div className="card-body">
            {loading && (
              <div>
                <Spinner />
              </div>
            )}
            {!loading && <Table columns={columns} data={transactions} />}
          </div>
        </div>
      </div>

     
    </div>
  );
};

export default Transactions;
